import {
  getAnalytics,
  logEvent as firebaseLogEvent,
  setAnalyticsCollectionEnabled
} from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

// const isProd = process.env.NODE_ENV !== 'development'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Services should be disabled on dev env
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Disables event logging on dev env
async function logEvent(eventName, eventParams) {
  // if(!isProd) return

  if (analytics) {
    firebaseLogEvent(analytics, eventName, eventParams);
    setAnalyticsCollectionEnabled(analytics, true);
  } else {
    console.error('Firebase Analytics is not properly initialized.');
  }
}

export default {
  app,
  analytics,
  logEvent
};
